<!-- Main Toolbar -->
<div class="relative flex flex-row px-4 py-4 shadow-md"
     [ngClass]="cssService.toolbarBgDashboardClass">

  <div class="flex flex-row items-center gap-4">

    <!-- Bouton ouverture sidenav -->
    <button mat-icon-button *ngIf="!opened" (click)="toggleParent()" angulartics2On="click"
            angularticsAction="openSideNav" angularticsCategory="headers" angularticsLabel="customer-side">
      <mat-icon>menu</mat-icon>
    </button>

    <!-- Icône au centre -->
    <div *ngIf="!domainUser">
      <img src="assets/img/refonte-logo/logo_myfulle.png" class="h-8 w-auto">
    </div>

  </div>

  <div class="flex-1"></div>

  <div>
    <button mat-icon-button [matMenuTriggerFor]="menu" angulartics2On="click" angularticsAction="openMenu"
            angularticsCategory="headers" angularticsLabel="customer-side">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #menu="matMenu">

      <ng-template matMenuContent>

        <button mat-menu-item (click)="logOut()" angulartics2On="click" angularticsAction="logout"
                angularticsCategory="headers" angularticsLabel="customer-side">
          <mat-icon>exit_to_app</mat-icon>
          <span>{{"header.menu.logout" | translate}}</span>
        </button>

      </ng-template>

    </mat-menu>
  </div>

</div>
